import { useQuery } from '@tanstack/react-query'
import { voiceApi } from '../../api/voice'
import { useSpoke } from '../../hooks/useSpoke'
import { formatDate } from '../../lib/format'
import { scenarioLabel } from '../../lib/voice'

export function HistoryPanel() {
  const spoke = useSpoke()
  const q = useQuery({ queryKey: ['voice-history', spoke], queryFn: () => voiceApi.history(spoke) })
  if (!q.isSuccess) return null
  const { revisions, builds, drafts } = q.data
  return (
    <details className="card history-card">
      <summary><h2>History</h2><span className="muted">{revisions.length} revisions · {builds.length} reads · {drafts.length} drafts</span></summary>
      <div className="two-up">
        <div>
          <h3>Profile revisions</h3>
          {revisions.length === 0 && <p className="muted">None yet.</p>}
          <ul className="plain">
            {revisions.map((r) => (
              <li key={r.revision}>
                <strong>Revision {r.revision}</strong> · {formatDate(r.builtAt)} · {r.messageCount} messages · {r.scenarioCount} scenarios {r.provisional && <span className="tag">measured only</span>}
              </li>
            ))}
          </ul>
          <h3>Builds</h3>
          <ul className="plain">
            {builds.map((b) => (
              <li key={b.id}>
                {formatDate(b.createdAt)} · <span className={`status ${b.status.toLowerCase()}`}>{b.status}</span>
                {b.error && <span className="error"> · {b.error}</span>}
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h3>Drafts</h3>
          {drafts.length === 0 && <p className="muted">No drafts yet.</p>}
          <ul className="plain">
            {drafts.map((d) => (
              <li key={d.id}>
                <strong>{formatDate(d.createdAt)}</strong> · {scenarioLabel(d.scenario)} · “{d.brief}”
                {d.editDistance !== null && <span className="muted"> · edited {Math.round(d.editDistance * 100)}%</span>}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </details>
  )
}
